import Vue from "vue";

import ApiService from "@/common/api.service";
import MeetingService from "@/common/meeting.service";

import {
  CHECK_CODE_WITH_LOCATION,
  CHECK_FOR_MEETING,
  CHECK_FOR_ROOMS,
  CHECK_MEETING_FOR_VLAN,
  DOES_MAC_EXIST,
  GET_MEETING,
  GET_MEETING_ROOMS,
  GET_SPLASH_PAGE,
  APPLY_ACCESS_CODE,
  GET_MEETING_MOTD
} from "@/store/actions.type";

import {
  SET_CURRENT_MEETING,
  SET_SPLASH_PAGE,
  SET_ACCESS_CODE,
  SET_VALID_CODE,
  SET_MOTD
} from "@/store/mutations.type";

const state = {
  currentMeeting: false,
  splashPage: {},
  accessCode: "",
  validCode: false,
  motd: ""
};

export const actions = {
  async [GET_MEETING_MOTD](context, payload) {
    let meeting_id = payload.meeting_id ? payload.meeting_id : null;
    let session_id = payload.session_id ? payload.session_id : null;
    const data = await MeetingService.getMeetingMotd(meeting_id, session_id);
    context.commit(SET_MOTD, data['data']);
    return data['data'];
  },
  async [APPLY_ACCESS_CODE](context, payload) {
    context.commit(SET_ACCESS_CODE, payload);
  },
  async [CHECK_CODE_WITH_LOCATION](context, payload) {
    let accessCode = payload.accessCode ? payload.accessCode : "";
    let location_id = payload.location_id ? payload.location_id : "";
    const data = await MeetingService.checkCodeWithLocation(
      accessCode,
      location_id
    );
    return data["data"];
  },
  async [CHECK_FOR_MEETING](context, payload) {
    const data = await MeetingService.checkForMeeting();
    return data["data"];
  },
  async [CHECK_FOR_ROOMS](context, payload) {
    const data = await MeetingService.checkForRooms();
    return data["data"];
  },
  async [CHECK_MEETING_FOR_VLAN](context, payload) {
    let session_id = payload.session_id ? payload.session_id : "";
    const data = await MeetingService.checkMeetingForVlan(session_id);
    context.commit(SET_CURRENT_MEETING, data["data"]);
    return data["data"];
  },
  async [DOES_MAC_EXIST](context, payload) {
    const data = await MeetingService.doesMacExist();
    return data["data"];
  },
  async [GET_MEETING](context, payload) {
    let meeting_id = payload.meeting_id ? payload.meeting_id : "";
    const data = await MeetingService.getMeeting(meeting_id);
    context.commit(SET_CURRENT_MEETING, data["data"]["data"]);
    return data["data"];
  },
  async [GET_MEETING_ROOMS](context, payload) {
    const data = await MeetingService.getMeetingRooms();
    return data["data"];
  },
  async [GET_SPLASH_PAGE](context, payload) {
    let meeting_id = payload.meeting_id ? payload.meeting_id : "";
    const data = await MeetingService.getSplashPage(meeting_id);
    context.commit(SET_SPLASH_PAGE, data["data"]["data"]);
    return data["data"];
  }
};

export const mutations = {
  [SET_CURRENT_MEETING](state, data) {
    state.currentMeeting = data;
  },
  [SET_SPLASH_PAGE](state, data) {
    state.splashPage = data;
  },
  [SET_ACCESS_CODE](state, data) {
    state.accessCode = data;
  },
  [SET_VALID_CODE](state, data) {},
  [SET_MOTD](state, data) {
    state.motd = data.data.meeting_bulletin;
  }
};

const getters = {
  currentMeeting(state) {
    return state.currentMeeting;
  },
  splashPage(state) {
    return state.splashPage;
  },
  accessCode(state) {
    return state.accessCode;
  },
  validCode(state) {
    return state.validCode;
  },
  motd(state) {
    return state.motd;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
